import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/(main)/blog/[slug]/blog-post-client.tsx");
